export default "__VITE_ASSET__BSnAjzHX__"